module.exports = __webpack_public_path__ + "static/assets/3921d63bd2206ea3a6119b1a2ab9c14e.svg";